import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LookupsComponent } from './lookups.component';
import { LookupComponent } from './lookup/lookup.component';
import { LookupGroupComponent } from './lookup-group/lookup-group.component';
import { LookupsRoutingModule } from './lookups-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from '../core/auth.module';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { LookupItemComponent } from './lookup-item/lookup-item.component';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { LookupService } from '../shared/Services/LookupService.service';

@NgModule({
  declarations: [LookupsComponent, LookupComponent, LookupGroupComponent,LookupItemComponent],
  imports: [
    CommonModule,
    LookupsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    SubheaderModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    LookupService
  ]
})
export class LookupsModule { }
